/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum RoleNames {
  READ_ONLY="READ_ONLY",
DISPATCHER="DISPATCHER",
DRIVER="DRIVER",
ROUTICIAN="ROUTICIAN",
API_OPTIMIZATION="API_OPTIMIZATION",
CHROME_EXTENSION="CHROME_EXTENSION",
DEBUG="DEBUG",
DRIVER_LOCATION_SERVICE="DRIVER_LOCATION_SERVICE",
DELIVERY_TRACKER_SERVICE="DELIVERY_TRACKER_SERVICE",
ADMIN="ADMIN"
}

/**
* RoleNames
*/
export const RoleNamesEnumType = types.enumeration("RoleNames", [
        "READ_ONLY",
  "DISPATCHER",
  "DRIVER",
  "ROUTICIAN",
  "API_OPTIMIZATION",
  "CHROME_EXTENSION",
  "DEBUG",
  "DRIVER_LOCATION_SERVICE",
  "DELIVERY_TRACKER_SERVICE",
  "ADMIN",
      ])
